<script>
export default {
  props: {
    msg: {
      type: String,
      required: false,
      default: ""
    }
  }
};
</script>

<template>
  <div class="loading-indicator">
    <img class="loading-indicator__spinner" src="@/assets/icons/loader.gif" alt="loading indicator" />
    <span class="loading-indicator__text">
      {{ $t("loading-indicator.loading.msg") }}
    </span>
    <span v-if="msg" class="loading-indicator__msg">
      {{ msg }}
    </span>
  </div>
</template>

<style lang="scss" scoped>
.loading-indicator {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  &__text {
    display: none;
  }

  img {
    max-width: 60px;
  }
}

.loading-indicator.inline {
  position: relative;
  background: none;
}

.loading-indicator.text {
  flex-direction: column;
  padding: 11px 0 4px 0px;

  .loading-indicator__text {
    display: block;
    margin: 5px 5px 0 0;
  }
}

.loading-indicator.large {
  img {
    height: 80px;
  }
}

.loading-indicator.padded {
  //margin: 100px;
  margin: 30px 0;
}
</style>
